// extracted by mini-css-extract-plugin
export default {"switchWrapper":"PaymentModeSwitch_switchWrapper__wVS3E"};